import { PricingSheetState } from '../../../../../shared/types';
import { PricingSheetTableData } from '../../../../../shared/types/pricingSheets';
import { DataTableColumnFilterProps } from '../../../components/Common/DataTable/DataTableColumnFilter';
import getSheetState from '../../../helpers/getSheetState';
import { RenderComponentProps } from '../../OfferSheets/OfferSheetsTable/OfferSheetsTable';

type PricingSheetTableColumnFilterProps = RenderComponentProps<
  DataTableColumnFilterProps<PricingSheetTableData>['renderColumnFilter']
>;

export const PricingSheetTableColumnFilter: PricingSheetTableColumnFilterProps =
  ({
    key,
    filterComponentProps,
    InputFilter,
    SelectFilter,
    DateFilter,
  }) => {
    switch (key) {
      // NUMBER INPUT
      case 'id':
        return (
          <InputFilter
            {...filterComponentProps}
            inputProps={{ type: 'number', min: '1' }}
          />
        );
      // TEXT INPUT
      case 'customerName':
      case 'name':
      case 'responsiblePerson':
      case 'site':
        return <InputFilter {...filterComponentProps} />;
      // SELECT
      case 'state': {
        const getOptions = (array: PricingSheetState[]) =>
          array.map((state) => ({
            key: state,
            label: getSheetState(state),
          }));
        let selectFilterOptions = getOptions([
          PricingSheetState.OkDraft,
          PricingSheetState.Approved,
          PricingSheetState.InUse,
          PricingSheetState.Pending,
          PricingSheetState.Ready,
        ]);

        return (
          <SelectFilter
            {...filterComponentProps}
            options={selectFilterOptions}
          />
        );
      }
      // DATE
      case 'createdAt':
      case 'to':
        return <DateFilter {...filterComponentProps} />;
    }
  };
